import React from 'react';
import { Box, Container, Heading, Text, VStack } from '@chakra-ui/react';
import FeatureGatesTable from '@components/general/feature-gates-table/feature-gates-table.component';

/**
 * Feature Gate Details page
 * This page displays all feature gates and their statuses in an interactive table
 *
 * @returns {JSX.Element} Feature Gate Details page
 */
export default function FeatureGateDetailsPage() {
  return (
    <Container
      maxW='container.lg'
      py={8}
    >
      <VStack
        spacing={6}
        align='stretch'
      >
        <Box>
          <Heading
            as='h1'
            size='xl'
            mb={2}
          >
            Feature Gate Details
          </Heading>
          <Text
            fontSize='lg'
            color='surface.onSurfaceVariant'
            mb={6}
          >
            View and monitor all feature gates across the application. The table below shows
            detailed information about each feature flag, including status, activity, and
            configuration. Expand rows to see rules, conditions, and additional metadata.
          </Text>
        </Box>

        <FeatureGatesTable />
      </VStack>
    </Container>
  );
}
